import React, {useEffect} from "react"
import {Row, Col, Grid} from "react-bootstrap"
import {RouteComponentProps} from "react-router-dom"

import UserRewardPointsWidget from "@irati-web/wallet/src/components/UserRewardPointsWidget"
import ManagerRewardPointsWidget from "@irati-web/wallet/src/components/ManagerRewardPointsWidget"
import tracking from "@irati-tracking/recognition/navigation"
import OpenPollsQuery from "@irati/recognition/apollo/query/OpenPolls"
import {Query} from "@irati/utils/services/apollo"
import {POLL, RECOGNITION} from "@irati/recognition/constants/feedTypes"
import {REWARD} from "@irati/recognition/constants/recognitionViewTypes"
import {feedPollQuery} from "@irati/recognition/apollo/query/FeedPoll"
import {feedRecognitionQuery} from "@irati/recognition/apollo/query/FeedRecognition"

import Layout from "../../components/Layout"
import Onboarding from "../../components/Onboarding"
import PollPopup from "../../components/Popup/Poll"
import VotesPopup from "../../components/Popup/Votes"
import RecognitionPopup from "../../components/Popup/Recognition"
import ErrorPopup from "../../components/Popup/Error"
import {OpenPolls, ClosedPolls, PollsTitle} from "../../components/Polls"
import RecognitionBanner from "../../components/RecognitionBanner"
import bannerImg from "../../images/recognition-banner.png"

interface Props extends RouteComponentProps<{type: string; uuid: string}> {}

const Recognition: React.FC<Props> = (props) => {
  const {
    params: {type, uuid, view}
  } = props.match
  useEffect(() => {
    tracking.viewRecognition()
  }, [])
  const pollId = type === POLL ? uuid : null
  const recognitionId = type === RECOGNITION ? uuid : null
  return (
    <Layout bannerImg={bannerImg} bannerChild={<RecognitionBanner />}>
      <Grid>
        <Row>
          <Col xs={12} md={4}>
            <Col xs={12} sm={6} md={12}>
              <ManagerRewardPointsWidget />
            </Col>
            <Col xs={12} sm={6} md={12}>
              <UserRewardPointsWidget />
            </Col>
            <Col xs={12}>
              <PollsTitle />
              <OpenPollsQuery>{({data: {polls}}) => <OpenPolls polls={polls.results} />}</OpenPollsQuery>
            </Col>
          </Col>
          <Col xs={12} md={8}>
            <ClosedPolls />
          </Col>
        </Row>
      </Grid>
      <Onboarding />
      {pollId && (
        <Query query={feedPollQuery.query} variables={{id: pollId}} Error={ErrorPopup}>
          {({data: {poll}}) => (poll.active ? <VotesPopup poll={poll} redirectToFeed /> : <PollPopup poll={poll} redirectToFeed />)}
        </Query>
      )}
      {recognitionId && (
        <Query query={feedRecognitionQuery.query} variables={{id: recognitionId}} Error={ErrorPopup}>
          {({data: {recognition}}) => <RecognitionPopup recognition={recognition} hasReward={view === REWARD} key={view} redirectToFeed />}
        </Query>
      )}
    </Layout>
  )
}

export default Recognition
